import { useQuery } from "@tanstack/react-query";
import React, { useEffect, useRef, useState } from "react";
import axios from "../../api/axios";
import toast from "../sweetalert/Sweetalert";
import { destroySession } from "../../helpers/Session";
import { useNavigate } from "react-router-dom";
import { useShiftData } from "../../hooks/shiftData";

const Payperiod = () => {
    const navigate = useNavigate();
    const { setShiftData } = useShiftData();

    const timeoutRef = useRef(null);

    const accesstoken = sessionStorage.getItem('accesstoken');

    const [selectedYear, setSelectedYear] = useState(null);
    const [activePayperiod, setActivePayperiod] = useState(0);

    const { data: years, isLoading: isLoadingYears, error: errorYears } = useQuery({
        queryKey: ['payperiodyears'],
        queryFn: async () => {
            const res = await axios.get('payperiods/years', {
                headers: { 'Authorization': `Bearer ${accesstoken}` }
            });
            return res.data.response;
        },
        staleTime: Infinity
    });

    const currentYear = selectedYear || (years && years[0]?.year);

    const { data: payperiods, isLoading: isLoadingPayperiods, error: errorPayperiods } = useQuery({
        queryKey: ['payperiodlists', currentYear],
        queryFn: async () => {
            const res = await axios.get(`payperiods/years/${currentYear}`, {
                headers: { 'Authorization': `Bearer ${accesstoken}` }
            });
            return res.data.response;
        },
        enabled: !!currentYear,
        staleTime: Infinity
    });

    useEffect(() => {
        if (errorYears || errorPayperiods) {
            const errorMsg = errorYears?.response?.data?.response || errorPayperiods?.response?.data?.response;
            toast.fire({ icon: 'error', title: errorMsg });

            if (errorYears?.response?.data.status === 'inactive' || errorPayperiods?.response?.data.status === 'inactive') {
                destroySession();
                clearTimeout(timeoutRef.current);
                timeoutRef.current = setTimeout(() => { navigate('/error'); }, 1000);
            }
        }
    }, [errorYears, errorPayperiods, navigate]);

    const handleSetYear = (e) => {
        setSelectedYear(e.target.value);
        setShiftData('payperiod', null);
        setShiftData('employee', null);
    };

    const handleSetCurrentPayperiod = (id) => {
        setActivePayperiod(id);
        setShiftData('payperiod', id);
        setShiftData('employee', null);
    };

    return (
        <div className="payperiod-selection">
            <div className="panel">
                <div className="panel-title">
                    <h3>Payperiods</h3>
                </div>
                <div className="panel-content">
                    <select onChange={handleSetYear} defaultValue="">
                        {years?.map((item) => (
                            <option key={item.id} value={item.year}>{item.year}</option>
                        ))}
                    </select>
                    <ul className={isLoadingYears || isLoadingPayperiods ? 'loading' : ''}>
                        {isLoadingYears || isLoadingPayperiods ? (
                            [...Array(10)].map((_, i) => (
                                <li key={i}><span></span></li>
                            ))
                        ) : (
                            payperiods?.map((item) => (
                                <li key={item.id} className={activePayperiod === item.id ? 'active' : ''} onClick={() => handleSetCurrentPayperiod(item.id)}>
                                    <span>{item.sdate} - {item.edate}</span>
                                </li>
                            ))
                        )}
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default Payperiod;
